const copyToClipboardActions = {
	UTILITY_COPY_TO_CLIPBOARD: 'UTILITY_COPY_TO_CLIPBOARD',
	copyToClipboard: ({ text, message }) => ({
		type: copyToClipboardActions.UTILITY_COPY_TO_CLIPBOARD,
		text,
		message,
	}),
};

export default copyToClipboardActions;
